import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import{fetchhoslogsWorkdays} from '../actions/index';
import Workday from './workday';
import ActivityModal from './activity-modal';
import CommentsModal from './comments-modal';
import NotesModal from './notes-modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import {constants, KeolisSpinner, moment,Pagination} from './common/commonExport';
import AdminCommonSection from '../components/adminLayout';
import apiConst from '../../../constants/const'

import DateTime from 'react-datetime';
import PDFPrinting from './PDFPrinting';


 

 const UserHistoricalWorkdays =()=>{
  //  const authState = useSelector((state) => state.authState);
    const props = useSelector((state) => state);
    const dispatch = useDispatch();    
    const [ dateError, setDateError] = useState('');      
    const [showWorkDays, setShowWorkDays] = useState(false); 
    const [cutOffDate, setCutOffDate] = useState('12/31/2022'); //default cut off date
    const [filter, setFilter] = useState(
        {
            workdayDateFrom:'',
            workdayDateTo:'',
            currentPageNum:1,
            excludeCertified:false,
            excludeOffDay: false
           
        }
    );  

     
  
  
    function clearDate(e, prop){      
      e.preventDefault();
      if(prop == 'fromDate'){
    //  setFromDate('')
      updateFilter('workdayDateFrom','');
      } else if(prop == 'toDate'){
          updateFilter('workdayDateTo','');
         
      }  
  }
  
  
      // changing Date in DatePicker
     function changeDate(date, dateSelection) {
         setDateError('');
       if(dateSelection == 'fromDate'){
              if ((date.length == 2 || date.length == 5) && date.length != undefined ){
                  date += '/';

                      updateFilter('workdayDateFrom',date);
              } else {
                  if(date.length == undefined){
                      var selectedDate = moment(date);
                      selectedDate = selectedDate.format('MM/DD/YYYY');
                      updateFilter('workdayDateFrom',selectedDate);
                  }
           }
           

          } 
          else if(dateSelection == 'toDate'){   

              if (date.length == 2 || date.length == 5 ){
                  date += '/';

                  updateFilter('workdayDateTo',date);
              } else if(date.length == undefined) 
                {
                    var selectedDate = moment(date);
                    selectedDate = selectedDate.format('MM/DD/YYYY');
 
                    updateFilter('workdayDateTo',selectedDate);
                }
                
                moment(date) < moment(filter.workdayDateFrom)?setDateError('To date cannot be less than from date'):setDateError('');
          
          }
      }

       function validFromDate( current ){
        return current.isAfter( cutOffDate );
    }

          // get workdays when loading workdays component
   function fetchWorkdays(fetchObj) {
        dispatch(fetchhoslogsWorkdays(fetchObj));
    }

 function onHastusRefresh()
 {

    if(filter.workdayDateFrom=='' || filter.workdayDateTo =='')
    {
       return;
    }

   if(moment(filter.workdayDateFrom).isBefore(moment(filter.workdayDateTo).subtract(30, "days")))
    {
    setDateError('End date cannot be more than 30 days after the start date');
    return;
    }
   setShowWorkDays(true);
   updateFilter('currentPageNum', 1);
   let workday_date = Array.isArray(props.workdays.workdays) && props.workdays.workdays.length > 0 ? props.workdays.workdays[0].wdy_date : '';
   let workday_date_formated = workday_date ? moment(workday_date, 'MM/DD/YYYY').format('YYYYMMDD') : '';
   
   let empId = props.authState.impersonateUserId > 0? props.authState.impersonateUserId:props.authState.employeeID,
       fetchObj = {
       url:constants.actionUrls.GET_USER_HASTUS_DATA,
       role: 'emp',
       empId:empId,
       source: 'web',
       pageNum:1,
       workdayDate: workday_date_formated,
       pay_certify_status: props.workdays.workdays.length > 0 ? props.workdays.workdays[0].wdy_certify_status_pay : '',
       startDate: filter.workdayDateFrom,
       endDate:filter.workdayDateTo,
       isRefresh : true,
       route:constants.HISTORICAL_LOGS,  
       excludeCertified:filter.excludeCertified,
       excludeOffDay:filter.excludeOffDay
   }
   fetchWorkdays(fetchObj);

 }


   function checkPrevNonCertifiedWokrday(row, workdays) {
        let nonCertifiedWorkdays,
            wdy_date = row.wdy_date;
        //not certified   
        nonCertifiedWorkdays = workdays.filter(function (value) {
            return value.wdy_certify_status === 'U' && value.dutyActivityStatus === 'Y';
        });

        //filtered is after the current row workdate date 
        let filtered = nonCertifiedWorkdays.filter(function (value) {
            
            //get restbreak records filtering with current row date 
            let hasRestBreakRecord = nonCertifiedWorkdays.filter(value => {
                return value.wdy_date === wdy_date
            })
            //length greater than 1 will be rest break records
            if(hasRestBreakRecord.length > 1){
                let result = false;
                hasRestBreakRecord.every(function(element){
                    // check date of restbreak and current records && resbreak numbers are same  - 
                        // yes -> return isAfter for the date for restbreakno 1 (normal scenario)
                        // yes -> return isSameOrAfter for number 2, as restbreak 1&2 will the same date
                    if(wdy_date == element.wdy_date &&  row.RestBreakNo == element.RestBreakNo){
                        if(element.RestBreakNo == 1){
                            return result = moment(wdy_date, "MM-DD-YYYY").isAfter(moment(element.wdy_date, "MM-DD-YYYY"))
                        }
                        else if(element.RestBreakNo == 2){
                            return result = moment(wdy_date, "MM-DD-YYYY").isSameOrAfter(moment(element.wdy_date, "MM-DD-YYYY"))
                        }
                    }
                });
                return result;
            }
            else 
                return moment(wdy_date, "MM-DD-YYYY").isAfter(moment(value.wdy_date, "MM-DD-YYYY"))
        });
        //return editable true if array contains nothing
        return filtered.length <= 0;
    }

   function getEditIconValue(workday){
        var workdays = props.workdays.workdays;
        let editable =  checkPrevNonCertifiedWokrday(workday, workdays);
        var data = workdays.filter(function(item){  
            return item.Workday_id == workday.Workday_id && item.RestBreakNo == workday.RestBreakNo;
        });
        if(data != null){
            if(editable){
                if(data.length > 1){
                    var workId = -1;
                    var amendmentId = -1;
                    data.forEach(work => {
                        if(parseInt(work.AmendmentId) > parseInt(amendmentId)) {
                            amendmentId = parseInt(work.AmendmentId);
                            workId = work.id;
                        }
                        if(workday.id == workId)
                            editable = true;
                        else
                            editable = false
                    })
                }
            }
            return editable;
        }
        return editable;
    }  
  function  getEditIcon(){
        let workdays = props.workdays.workdays;
        var array = [];
        workdays.forEach(workday => {
            let value = getEditIconValue(workday);
            array.push(value);
        });
        return array;
    }
function renderWorkdays()
{
   if(showWorkDays===false)
   {
    return (
        <tr>
                    <td colSpan="100%">
                      Please select from and to date to search records 
                    </td>
                </tr>
    )
   }


    var iconArray = getEditIcon();
        var workdays = props.workdays.workdays, role = props.authState.impersonateUserId > 0?constants.roles.EMPLOYEE_ROLE:props.authState.role;
     
        if (workdays && workdays.length > 0) {
           
            return (
                workdays.map(function (workday, index) {
                    return (<Workday isEditable={iconArray[index]} workday={workday} key={index + workday.wdy_date} role={role} menutype = 'HosDetails'/>);
                })
            )
        }
        else if (props.hasErrored) {
            return <div>Sorry some Error...</div>;
        } else if (props.workdays.isLoading) {
            return (
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        } else {
            return (
                <tr>
                    <td colSpan="100%">
                        No Records Available
                    </td>
                </tr>
            )
        }
}



    // rendering pagination component
   function renderPagination() {
    
        let workdays = props.workdays.workdays, totalPages =0 ;
      
        if(workdays && workdays.length > 0 ){           
            totalPages= workdays[0]["TotalPages"] > 0 ? workdays[0]["TotalPages"] : 0;           
       }
        
        return (<Pagination ShowPagination={totalPages > 0 ? true:false} currentPage={filter.currentPageNum}
            pageSize={totalPages} GetData={(currentPageNum, filterObj) => handlePagination(currentPageNum, filterObj)} />)
    }


     // handling pagination
    function handlePagination(pageNum, filterObj) {
        
        let empId = props.authState.impersonateUserId > 0? props.authState.impersonateUserId:props.authState.employeeID;              
      
      let  fetchObj = {
        url:constants.actionUrls.EMPLOYEE_HOS_LOGS_URL,
        role: 'emp',
        empId:empId,
        source: 'web',
        pageNumber:pageNum,
        startDate: filter.workdayDateFrom,
          endDate: filter.workdayDateTo,
          route: constants.HISTORICAL_LOGS,
        excludeCertified:filter.excludeCertified,
        excludeOffDay:filter.excludeOffDay
       
        }
        


    fetchWorkdays(fetchObj);
    //setCurrentPageNum(pageNum)
    updateFilter('currentPageNum',pageNum)
        
       
        

    }


    // rendering different modals as needed
    function renderModal() {

        if(props.notes.notesObj && props.notes.notesObj.showNotesModal){
            var modalStatus = props.notes.notesObj.showNotesModal;
            var modalName = props.notes.notesObj.modalName;
        } else {
            var modalStatus = props.modals.showModal;
            var modalName = props.modals.modalName;
        }
        if (modalStatus && modalName == "notes_Modal") {
            return (<NotesModal/>)
        } else if (modalStatus && modalName == constants.hosModals.Certify_Modal || modalName == constants.hosModals.Certified_Modal) {
            return (<ActivityModal isLogUser = {true}  islogAdmin = {props.authState.impersonateUserId > 0 && !apiConst.isImpersonateEditAllow} isWorkDaychange={props.workday.change} historicalStartDate= {filter.workdayDateFrom} historicalEndDate={filter.workdayDateTo}/>)
        } 
        else if (modalStatus && modalName == constants.hosModals.Comments_Modal) {
            
            return (<CommentsModal islogsUser = {true} historicalStartDate= {filter.workdayDateFrom} historicalEndDate={filter.workdayDateTo}/>)
        }
    }

    // on refresh button clicked
    function onRefresh(){
         if(filter.workdayDateFrom=='' || filter.workdayDateTo =='')
         {
            return;
         }
        if (moment(filter.workdayDateTo).isBefore(moment(filter.workdayDateFrom))) {
            setDateError('End date cannot be less than the start date');
            return;
        }
        setShowWorkDays(true);
        updateFilter('currentPageNum', 1);
        let workday_date = Array.isArray(props.workdays.workdays) && props.workdays.workdays.length > 0 ? props.workdays.workdays[0].wdy_date : '';
        let workday_date_formated = workday_date ? moment(workday_date, 'MM/DD/YYYY').format('YYYYMMDD') : '';
        
        let empId = props.authState.impersonateUserId > 0? props.authState.impersonateUserId:props.authState.employeeID,
            fetchObj = {
            url:constants.actionUrls.EMPLOYEE_HOS_LOGS_URL,
            role: 'emp',
            empId:empId,
            source: 'web',
            pageNum:1,
            workdayDate: workday_date_formated,
            pay_certify_status: props.workdays.workdays.length > 0 ? props.workdays.workdays[0].wdy_certify_status_pay : '',
            startDate: filter.workdayDateFrom,
            endDate:filter.workdayDateTo,
            isRefresh : true,
            route:constants.HISTORICAL_LOGS,  
            excludeCertified:filter.excludeCertified,
            excludeOffDay: filter.excludeOffDay           
        }
        fetchWorkdays(fetchObj);
    }



    let inputProps = {
        maxLength: 10, 
        placeholder: 'Select Date',
        readOnly: true,
    };
  
    function updateFilter(name,value) {
        setFilter((prev)=>({
                ...prev,
                [name]:value,
            })
        )
       
     }

     function getFetchObject(isExport=false) {
         let workday_date = Array.isArray(props.workdays.workdays) && props.workdays.workdays.length > 0 ? props.workdays.workdays[0].wdy_date : '';
         let workday_date_formated = workday_date ? moment(workday_date, 'MM/DD/YYYY').format('YYYYMMDD') : '';

         let empId = props.authState.impersonateUserId > 0 ? props.authState.impersonateUserId : props.authState.employeeID,
             fetchObj = {
                 url: constants.actionUrls.EMPLOYEE_HOS_LOGS_URL,
                 role: 'emp',
                 empId: empId,
                 source: 'web',
                 pageNum: 1,
                 workdayDate: workday_date_formated,
                 pay_certify_status: props.workdays.workdays.length > 0 ? props.workdays.workdays[0].wdy_certify_status_pay : '',
                 startDate: filter.workdayDateFrom,
                 endDate: filter.workdayDateTo,
                 isRefresh: true,
                 route: constants.HISTORICAL_LOGS,
                 excludeCertified: filter.excludeCertified,
                 excludeOffDay: filter.excludeOffDay,
                 isExport: isExport
             }
         return fetchObj;
     }

     function getSelectedCheckedData() { }

    
     let compTitle = "Hours of Service";
     let fetchObj = getFetchObject(true);
      return (
          <AdminCommonSection compTitle={compTitle} refreshTime={''}  admin={false} onRefresh={onRefresh.bind(this)}
              tblBody={
                  <>                           


                           
                      <div className="row">
                          <div className="col-md-1">
                              <span className="filterLbl">Date From</span>
                          </div>
                          <div className="col-md-2">
                              <span onClick={(e) => clearDate(e, 'fromDate')}></span>
                              <DateTime isValidDate={validFromDate} inputProps={inputProps} closeOnSelect timeFormat={false} value={filter.workdayDateFrom} onChange={(e) => changeDate(e, 'fromDate')} />
                          </div>
                          <div className="col-md-1">
                              <span className="filterLbl">Date To</span>
                          </div>
                          <div className="col-md-2">
                              <span onClick={(e) => clearDate(e, 'toDate')}></span>
                              <DateTime isValidDate={validFromDate} inputProps={inputProps} closeOnSelect timeFormat={false} value={filter.workdayDateTo} onChange={(e) => changeDate(e, 'toDate')} />
                              <div className={dateError && dateError.length > 0 ? "errAlertDiv alert alert-danger fade in" : "hidden"}>
                                  {dateError}
                              </div>
                          </div> 
                          <div class="col-md-3 col-sm-12">
                              <div>
                                  <span className="filterLbl">Exclude Certified</span>
                                  <input className="outlawChkBox" type="checkbox" name="excludeCertified" onChange={(e) => updateFilter(e.target.name, e.target.checked)} />
                                  
                              </div>
                              <div>
                                  <span className="filterLbl">Exclude OFF Day</span>
                                  <input className="outlawChkBox" type="checkbox" name="excludeOffDay" onChange={(e) => updateFilter(e.target.name, e.target.checked)} />
                              </div>
                          </div>

                          <div class="col-md-12 text-right">
                              <PDFPrinting Page="Projects" compTitle={compTitle} pageNo={1} fetchDataObj={fetchObj} route={constants.HISTORICAL_LOGS} />
                              <button className="btn btn-primary pull-right" onClick={() => onHastusRefresh()}>Hastus Refresh</button>
                          </div>
                      </div>
                <div>
                        <div id="tblMainActivities" className={"employeeTbl spaceFromBottom"} >
                            <Table className="table table-striped table-bordered_header table-condensed">
                                <Thead className="thead-default">
                                    <Tr>
                                        <Th>Service Date</Th>
                                        <Th>Type</Th>
                                        <Th className="hidden">14 Cycle</Th>
                                        <Th className="text-center">Total HOS</Th>
                                        <Th className="text-center">Status</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                {
                                  renderWorkdays()
                                }
                                </Tbody>
                            </Table>
                            {
                               renderModal()
                            }
                            
                        </div>
                       
                        {
                            renderPagination()
                        }
                        
                </div>
                  
                </>
              }
          />
      ); 
   
 }  

export default  UserHistoricalWorkdays;